
export const USER_INFO = '__user_info';
export const VESSEL_TYPES = {
  CARRIERS: 'Bulk Carrier',
  TANKERS: 'Tanker',
  CHEMICALS: 'Chemical Tanker',
  CONTAINERS: 'Container Vessel',
  OTHERS: 'Other'
};
